import { hasRole, type Role, type Session } from '@/shared/api';

/**
 * Wat deze sessie met rapporten mag, vóórdat er een rapport is om `can` van te
 * lezen (bijvoorbeeld: mag ik een eerste concept laten maken?). Staat er een
 * rapport, dan wint `report.can`: de API beslist per rapport.
 *
 * De permissies uit de sessie zijn leidend; ontbreken ze (een oudere sessie),
 * dan volgt dit de rollentabel uit `Identity\Enums\Role`: de eigenaar mag
 * alles, de inspecteur alleen inzien.
 */
export interface ReportAccess {
    view: boolean;
    /** Genereren en teksten aanpassen. */
    edit: boolean;
    approve: boolean;
    send: boolean;
    share: boolean;
    /**
     * De factuur meesturen met het rapport: die maakt Smartkeur dan zo nodig uit de
     * diensten en geeft haar een nummer, dus het vraagt opstellen én uitgeven.
     */
    invoice: boolean;
}

const OFFICE: readonly Role[] = ['owner'];

export function reportAccessFor(
    session: Pick<Session, 'user' | 'roles' | 'permissions'> | null,
): ReportAccess {
    const permissions = session?.permissions ?? [];
    const may = (permission: string) =>
        permissions.length > 0 ? permissions.includes(permission) : hasRole(session, OFFICE);

    return {
        view: permissions.length > 0 ? permissions.includes('reports.view') : session !== null,
        edit: may('reports.edit'),
        approve: may('reports.approve'),
        send: may('reports.send'),
        share: may('reports.share'),
        invoice: may('invoices.manage') && may('billing.manage'),
    };
}
